import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "list"
};
import { useStore } from '@/stores/pinia';
import Step1Content from './Step1Content.vue';
import { ApiGetPayment } from '@/services/user';
import { Toast } from 'vant';
export default /*#__PURE__*/_defineComponent({
  __name: 'Step2',
  setup(__props) {
    const store = useStore();
    const clickSubmit = async () => {
      const loading = Toast.loading({
        message: '提交中...',
        forbidClick: true
      });
      const res = await ApiGetPayment(String(store.formId));
      loading.clear();
      if (typeof res !== 'string') return Toast.fail('提交失败');
      if (res === 'success') return Toast.success('该订单已支付成功');
      console.log(res);
      window.location.href = res;
    };
    return (_ctx, _cache) => {
      const _component_van_cell = _resolveComponent("van-cell");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_action_bar_button = _resolveComponent("van-action-bar-button");
      const _component_van_action_bar = _resolveComponent("van-action-bar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [Number(_unref(store).nj.amount) * Number(_unref(store).nj.repeat) > 0 ? (_openBlock(), _createBlock(_component_van_cell_group, {
        key: 0,
        inset: "",
        class: "mb-2"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell, {
          title: "订单信息"
        }, {
          label: _withCtx(() => [_createVNode(Step1Content, {
            data: {
              订单编号: _unref(store).formId,
              订单金额: _unref(store).getBalance(),
              订单状态: '等待支付'
            }
          }, null, 8, ["data"])]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_van_cell_group, {
        inset: "",
        class: "mb-2"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell, {
          title: "以下为功德详情"
        })]),
        _: 1
      }), _createVNode(_component_van_cell_group, {
        inset: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell, {
          title: "念经"
        }, _createSlots({
          value: _withCtx(() => [_createVNode(Step1Content, {
            data: {
              每天金额: _unref(store).nj.amount + ' 元',
              重复天数: _unref(store).nj.repeat + ' 天',
              合计金额: Number((Number(_unref(store).nj.amount) * Number(_unref(store).nj.repeat)).toFixed(1)) + ' 元'
            }
          }, null, 8, ["data"])]),
          _: 2
        }, [_unref(store).nj.isFinished ? {
          name: "label",
          fn: _withCtx(() => [_createVNode(Step1Content, {
            data: {
              经咒内容: _unref(store).nj.checkList.map(v => v.text).join('、'),
              回向内容: _unref(store).nj.backContent
            }
          }, null, 8, ["data"])]),
          key: "0"
        } : undefined]), 1024)]),
        _: 1
      }), Number(_unref(store).pw.amount) * Number(_unref(store).pw.repeat) > 0 ? (_openBlock(), _createBlock(_component_van_cell_group, {
        key: 1,
        inset: "",
        class: "mt-2"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell, {
          title: "破瓦",
          value: _unref(store).nj.isFinished ? `编辑添加破瓦内容` : `点击添加破瓦内容`
        }, _createSlots({
          value: _withCtx(() => [_createVNode(Step1Content, {
            data: {
              每天金额: _unref(store).pw.amount + ' 元',
              重复天数: _unref(store).pw.repeat + ' 天',
              合计金额: Number((Number(_unref(store).pw.amount) * Number(_unref(store).pw.repeat)).toFixed(1)) + ' 元'
            }
          }, null, 8, ["data"])]),
          _: 2
        }, [_unref(store).pw.isFinished ? {
          name: "label",
          fn: _withCtx(() => [_createVNode(Step1Content, {
            data: {
              超度对象: _unref(store).pw.soul
            }
          }, null, 8, ["data"])]),
          key: "0"
        } : undefined]), 1032, ["value"])]),
        _: 1
      })) : _createCommentVNode("", true), Number(_unref(store).wg.amount) * Number(_unref(store).wg.repeat) > 0 ? (_openBlock(), _createBlock(_component_van_cell_group, {
        key: 2,
        inset: "",
        class: "mt-2 mb-14"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell, {
          title: "五供"
        }, {
          value: _withCtx(() => [_createVNode(Step1Content, {
            data: {
              合计金额: Number((Number(_unref(store).wg.amount) * Number(_unref(store).wg.repeat)).toFixed(1)) + ' 元'
            }
          }, null, 8, ["data"])]),
          default: _withCtx(() => [_createVNode(Step1Content, {
            data: {
              用途: _unref(store).wg.use,
              回向对象: _unref(store).wg.backObjectList.map(v => v.name).join('、')
            }
          }, null, 8, ["data"])]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_van_action_bar, {
        "safe-area-inset-bottom": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_van_action_bar, {
          "safe-area-inset-bottom": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_van_action_bar_button, {
            color: "#be99ff",
            type: "warning",
            text: "返回修改",
            onClick: _cache[0] || (_cache[0] = $event => _unref(store).active--)
          }), _createVNode(_component_van_action_bar_button, {
            type: "danger",
            onClick: clickSubmit,
            disabled: _unref(store).getBalance() <= 0,
            text: "前往支付"
          }, null, 8, ["disabled"])]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
});